import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="px-6 md:px-20 lg:px-40 py-12 bg-white dark:bg-background-dark border-t border-slate-100 dark:border-white/5">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-12">
          <div className="col-span-2 space-y-4">
            <div className="flex items-center gap-2 text-primary">
              <div className="size-6 flex items-center justify-center bg-primary rounded-md text-white">
                <span className="material-symbols-outlined text-sm">bolt</span>
              </div>
              <h2 className="text-[#121118] dark:text-white text-lg font-bold">Formly AI</h2>
            </div>
            <p className="text-slate-500 dark:text-white/40 text-base leading-relaxed max-w-[240px]">
              تمكين المستخدمين بأدوات تصفح ذكية. ملء النماذج أصبح إنسانياً.
            </p>
          </div>
          <div>
            <h5 className="font-bold text-base mb-4">المنتج</h5>
            <ul className="space-y-2 text-base text-slate-500 dark:text-white/60">
              <li><a className="hover:text-primary transition-colors" href="#features">المميزات</a></li>
              <li><a className="hover:text-primary transition-colors" href="#">الأسعار</a></li>
              <li><Link to="/install" className="hover:text-primary transition-colors">الإضافة</Link></li>
              <li><a className="hover:text-primary transition-colors" href="#">سجل التغييرات</a></li>
            </ul>
          </div>
          <div>
            <h5 className="font-bold text-base mb-4">الشركة</h5>
            <ul className="space-y-2 text-base text-slate-500 dark:text-white/60">
              <li><a className="hover:text-primary transition-colors" href="#">من نحن</a></li>
              <li><a className="hover:text-primary transition-colors" href="#">سياسة الخصوصية</a></li>
              <li><a className="hover:text-primary transition-colors" href="#">شروط الخدمة</a></li>
              <li><a className="hover:text-primary transition-colors" href="#">اتصل بنا</a></li>
            </ul>
          </div>
          <div>
            <h5 className="font-bold text-base mb-4">الموارد</h5>
            <ul className="space-y-2 text-base text-slate-500 dark:text-white/60">
              <li><Link to="/documentation" className="hover:text-primary transition-colors">التوثيق</Link></li>
              <li><a className="hover:text-primary transition-colors" href="#">مركز المساعدة</a></li>
              <li><Link to="/blog" className="hover:text-primary transition-colors">المجتمع</Link></li>
            </ul>
          </div>
          <div>
            <h5 className="font-bold text-base mb-4">تواصل معنا</h5>
            <div className="flex gap-4">
              <a className="size-8 rounded-full bg-slate-100 dark:bg-white/5 flex items-center justify-center hover:text-primary transition-colors" href="#"><span className="material-symbols-outlined !text-[20px]">public</span></a>
              <a className="size-8 rounded-full bg-slate-100 dark:bg-white/5 flex items-center justify-center hover:text-primary transition-colors" href="#"><span className="material-symbols-outlined !text-[20px]">share</span></a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-slate-100 dark:border-white/5 flex flex-col md:flex-row justify-between gap-4 text-sm text-primary">
          <p>© 2024 Formly AI Inc. جميع الحقوق محفوظة.</p>
          <p>مصمم للإنتاجية.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

